export default {
  "fr": {
    "customer": {
      "actions": {
        "addCompany": "Ajouter une entreprise",
        "addCustomer": "Ajouter Client",
        "addSecondaryContact": "Ajouter contact secondaire",
        "add_email_address": "Ajouter une adresse e-mail",
        "bulk_import": "Importation de clients",
        "cancel": "Annuler",
        "changeProfilePicture": "Changer l'image du profil",
        "createNewCustomer": "Ajouter votre client...",
        "goToCustomerProfile": "Aller à la page contact client",
        "new": "Nouveau Client",
        "profilePictureFormat": "L'image doit être <strong>carrée</strong> et au moins <strong>300x300px</strong>",
        "removeCompany": "Supprimer les détails de l'entreprise",
        "removeCustomer": "Désassigner ce Client",
        "removeSecondaryContact": "Supprimer contact secondaire",
        "save": "Enregistrer",
        "searchCustomer": "Rechercher Client",
        "submit": "Enregistrer",
        "uploadProfilePicture": "Télécharger une image du profil"
      },
      "attributes": {
        "address": "Adresse",
        "birth_date": "Date de naissance",
        "categories": {
          "enduser": "Acheteur-Occupant",
          "investor": "Investisseur"
        },
        "category": "Type de Client",
        "company_name": "Nom de l'entreprise",
        "company_vat": "Numéro de TVA",
        "email_address": "Email",
        "email_address_secondary": "Email contact secondaire",
        "email_notifications_interval": {
          "daily": "Une fois par jour (vers midi)",
          "hourly": "Toutes les heures",
          "twice_daily": "Deux fois par jour (midi/soir)",
          "weekly": "Une fois par semaine (lundi midi)"
        },
        "first_name": "Prénom",
        "iban": "IBAN",
        "internal_note": "Note interne",
        "language": "Langue",
        "last_name": "Nom",
        "phone_landline": "Numéro fixe",
        "phone_mobile": "Numéro de portable",
        "status": "Status"
      },
      "import": {
        "fill_customer_info": "Remplir le modèle avec les informations client",
        "fix_file_upload_customer": "Veuillez résoudre les problèmes et télécharger à nouveau le fichier.</br>Les clients existants ne seront pas supprimés, mais seront mis à jour si quelque chose a changé dans le fichier de ce client depuis le dernier téléchargement."
      },
      "labels": {
        "customerAddedState": "<b>Pas encore invité.</b> Un e-mail d'invitation sera envoyé une fois que {name} aura accès à une unité affectée.",
        "customerAddedStateNoEmailAddress": "<b>Aucune adresse e-mail connue.</b> Une adresse e-mail est nécessaire pour permettre à {name} d'accéder à une unité affectée.",
        "hasAccessToUnit": "A accès en ligne",
        "information": "Vos Informations",
        "noCustomersYet": "Pas encore de clients sur la plateforme",
        "noEmailAddress": "Pas d'adresse e-mail",
        "noUnits": "Aucune unité encore assignée",
        "notSharedWithCustomer": "Non visible pour le client",
        "notificationDisclaimer": "Chaque fois quelque chose de nouveau est disponible pour vous, vous recevrez une notification. Si vous n'avez pas encore lu ces notifications sur la plateforme, elles seront regroupées et envoyées par e-mail. Ci-dessous, vous pouvez désactiver les notifications sur certains sujets et augmenter/diminuer la fréquence des e-mails.",
        "onPlatform": "Sur Plateforme",
        "otherSettings": "Autres réglages",
        "password": "Mot de passe",
        "primaryContact": "Vos détails",
        "secondaryContact": "Contact secundaire",
        "sharedWithCustomer": "Visible pour le client",
        "units": "Unités",
        "viaEmail": "Par Email"
      },
      "messages": {
        "integrationUpdateInformation": "Veuillez nous contacter si vous souhaitez mettre à jour certaines informations."
      },
      "toasts": {
        "birthday": "Joyeux anniversaire, {first_name}!",
        "create": "Client créé",
        "delete": "Client supprimé",
        "update": "Client modifié",
        "upload": "Tous les clients ont été importés avec succès"
      },
      "validation": {
        "needFirstName": "Prénom requis",
        "needFirstNameSecondary": "Prénom contact secondaire requis",
        "needLastName": "Nom requis",
        "needLastNameSecondary": "Nom contact secondaire requis"
      }
    }
  }
}